import React, {useState, useRef, useEffect} from 'react';
import "./../../assets/styles/styles.css";
import LoginEmail from './components/loginEmail';
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase";
import {loginUser} from './../../actions/userActions';
import {useDispatch, useSelector} from 'react-redux';

firebase.initializeApp({
    apiKey: "AIzaSyD8xbbaaM_SKc4Z1mCNkAr6h0aM8khrrBw",
    authDomain: "participacion-ciudadana-267718.firebaseapp.com"
});

const uiConfig = {
    signInFlow: "popup",
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    callbacks: {
        signInSuccessWithAuthResult: () => false
    }
}

function Login({onBackgroundPress}){

    const dispatch = useDispatch();
    const [step, svstep] = useState("select-method");
    const background = useRef(null);
    const user = useSelector(state => state.user.user);

    const renderSelectMethod = () => {
        return <React.Fragment>
            {/*<div style={{height:10}}></div>
            <BtFacebook/>
            <div style={{height:10}}></div>
            <BtTwitter/>
            <div style={{height:10}}></div>
            <BtGoogle/>*/}
        </React.Fragment>
    }

    const clickBackground = (event) => {
        if(event.target === background.current){
            onBackgroundPress();
        }
    }


    useEffect(() => {
        
        firebase.auth().onAuthStateChanged(userData => {
            if(user === null && userData && step !== ""){
                svstep("");
                let data;
                if(userData.emailVerified === false){
                    data = {
                        type: "app_email",
                        name: userData.displayName,
                        id: userData.uid,
                        email: userData.email
                    };
                }else{
                    let userSocialNetwork = userData.providerData[0];
                    data = {
                        type: userSocialNetwork.providerId,
                        name: userSocialNetwork.displayName,
                        id: userSocialNetwork.uid,
                        email: userSocialNetwork.email
                    };
                }
                dispatch(loginUser(data));
            }
        });
    
        return () => {
            firebase.auth().signOut();
        }
    });

    return(
        <div className="row m-0 justify-content-center h-100 align-items-center contFixed" ref={background} onClick={(event) => clickBackground(event)}>
            <div className="contLogin">
                <div style={{marginBottom:20}}>
                    <img alt={""} src={require('./../../assets/img/logo.png')} style={{width:"100%"}}/>
                </div>
                {
                    step === "select-method" && <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
                }
                {
                    step === "login-email" && <LoginEmail/>
                }
            </div>
        </div>
    );

}

export default Login;
  